import React, { createContext, useContext, useEffect, useState } from "react";

const KEY_USER = "smokehouse_username";
const KEY_TEAM = "smokehouse_team";
const KEY_EMAIL = "smokehouse_email";
const PlayerContext = createContext(null);

export const PlayerProvider = ({ children }) => {
  const [username, setUsernameState] = useState(() => localStorage.getItem(KEY_USER) || "");
  const [team, setTeamState] = useState(() => localStorage.getItem(KEY_TEAM) || "");
  const [email, setEmailState] = useState(() => localStorage.getItem(KEY_EMAIL) || "");

  useEffect(() => { if (username) localStorage.setItem(KEY_USER, username); }, [username]);
  useEffect(() => { if (team) localStorage.setItem(KEY_TEAM, team); }, [team]);
  useEffect(() => { if (email) localStorage.setItem(KEY_EMAIL, email); }, [email]);

  const setUsername = (u) => setUsernameState(u);
  const setTeam = (t) => setTeamState(t);
  const setEmail = (e) => setEmailState(e);
  const clear = () => {
    localStorage.removeItem(KEY_USER);
    localStorage.removeItem(KEY_TEAM);
    localStorage.removeItem(KEY_EMAIL);
    setUsernameState("");
    setTeamState("");
    setEmailState("");
  };

  return (
    <PlayerContext.Provider value={{ username, team, email, setUsername, setTeam, setEmail, clear }}>
      {children}
    </PlayerContext.Provider>
  );
};

export const usePlayer = () => {
  const ctx = useContext(PlayerContext);
  if (!ctx) throw new Error("usePlayer must be used within PlayerProvider");
  return ctx;
};
